import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { Description, Image, Title } from "@/ui";
import classes from "./styles.module.scss";
import { QuickJobSearch } from "@/components";
import { resolveQuickSearchProps } from "@/functions/resolveQuickSearchProps";
import { stripTags } from "@/functions/stripTags";

const HERO_IMAGE =
  "https://cdn.sourceflow.co.uk/vsrd0sw8s8lukyp46szbc9d3mk7g";

// Formatted text fields can save empty markup (e.g. "<p><br></p>"), so check for visible text
const hasText = (value) =>
  typeof value === "string" ? stripTags(value).replace(/&nbsp;/g, "").trim() !== "" : !!value;

export const Hero = ({
  className,
  title,
  titleColor,
  titlePosition = "container",
  description,
  showContainer = true,
  image,
  ...props
}) => {
  const search = resolveQuickSearchProps(props);

  // With the blue container hidden, the title and description fall back to sitting over the image
  const titleOverImage = titlePosition === "image" || !showContainer;
  const descriptionVisible = hasText(description);
  const descriptionOverImage = descriptionVisible && !showContainer;
  const hasOverlay = titleOverImage || descriptionOverImage;
  const hasContainer = showContainer && (!titleOverImage || descriptionVisible);

  const heading = <Title title={title} tag="h1" className={clsx(titleColor, "m-0")} />;
  const body = descriptionVisible ? (
    <Description description={description} className={classes.hero__description} />
  ) : null;

  return (
    <div className={clsx(className, classes.hero, { [classes["hero--overlay"]]: hasOverlay })}>
      <figure className={classes.hero__img}>
        <Image
          img={image ? image.url : HERO_IMAGE}
          size="1920x"
          alt="Hero image"
          className="w-100"
          style={{ maxHeight: "600px", objectFit: "cover" }}
        />
      </figure>
      <div className={classes.hero__content}>
        <Container>
          <Row>
            <Col xs={12} md={8}>
              {hasOverlay && (
                <div className={classes.hero__overlay}>
                  {titleOverImage && heading}
                  {descriptionOverImage && body}
                </div>
              )}
              {hasContainer && (
                <div className={clsx(classes.hero__container, "bg-primary p-4 pe-5 me-6 rounded")}>
                  {!titleOverImage && heading}
                  {showContainer && body}
                </div>
              )}
              <QuickJobSearch variant={search.variant} fields={search.fields} />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Hero;
